export const EntityNameColumnId = 'entityDisplayName';
